import React, { useEffect } from 'react'

import { PrimaryNavigationEditEntity } from 'components/ui/primary-navigation/edit-entity'
import { SecondaryNavigation } from 'components/ui/secondary-navigation'
import { SectionHeader } from 'components/ui/section-header'
import { StatusGuard } from 'components/ui/status-guard'

import { connect } from 'containers/store'

import { actionCreators, GettyActionCreators } from 'domains/org/getty/actions'
import { GettyStore } from 'domains/org/getty/store'

import { pick } from 'helpers/core'
import { statusSelector } from 'helpers/status'

import { LayoutListOrFormPage } from 'layouts/list-or-form-page'

import styled from 'styled'

import { getAnalyticsSubnav } from '../subnav'

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;
  min-height: 500px;
`

const Iframe = styled.iframe`
  height: 1300px;
  width: 100%;
  border: 0;
  background-color: ${({ theme }) => theme.color.white};
`

type ConnectedProps = {
  analytics: GettyStore['getty']['analytics'];
};

type ActionProps = Pick<GettyActionCreators, 'gettyGetAnalyticsRequest'>;

type DirectProps = {};

type Props = ConnectedProps & ActionProps & DirectProps;

export const AnalyticsToursView = (props: Props) => {
  const { analytics, gettyGetAnalyticsRequest } = props

  // load new iframe sources if not already cached in redux.
  useEffect(() => {
    statusSelector.shouldLoad(analytics.status) && gettyGetAnalyticsRequest()
  })

  const analyticsData = statusSelector.data(analytics)

  return (
    <LayoutListOrFormPage
      nav={() => (
        <PrimaryNavigationEditEntity
          title="Analytics"
          navBackRoute="/"
          darkTheme
        />
      )}
      title="Tours"
      subnav={() => (
        <SecondaryNavigation
          navItems={getAnalyticsSubnav()}
        />
      )}
      content={() => (
        <>
          <SectionHeader heading="Getty Guide" />
          <StatusGuard status={analytics}>
            <Container>
              {analyticsData && analyticsData.tours && analyticsData.tours.dashboardUrl ? (
                <Iframe src={analyticsData.tours.dashboardUrl} />
              ) : (
                <p>Not currently available.</p>
              )}
            </Container>
          </StatusGuard>
        </>
      )}
    />
  )
}

export const AnalyticsTours = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  store => ({ analytics: store.getty.analytics }),
  pick(actionCreators, 'gettyGetAnalyticsRequest')
)(AnalyticsToursView)
